$(document).ready(function(){

  
// setInterval(function(){
//   if ($('label.tm_switch_label').hasClass('checked')){
//     var currentStateProt = true;
//   }
//   else{
//     var currentStateProt = false;
//   }

//   if (currentStateProt == true){
//     $('#tm_switch_btn').trigger('click');
//   }

//   console.log(currentStateProt);
  
// },100);

    $('.arGalSlider').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        nextArrow: $('.arNext'),
        prevArrow: $('.arPrev')
      });
      
    var glideMulti = new Glide('.ha_articles_carousel .glide.multi', {
        type: 'carousel',
        autoplay: 4000,
        perView: 1,
        gap:0,
    });
    
    
    glideMulti.mount();



    
});


